<template>
    <custom-letter-create :letter="letter" v-if="loaded"></custom-letter-create>
    <loading v-else/>
</template>
<script>
import {reactive,ref} from 'vue';
import Loader from './report/Loader.vue'
import {useRoute} from 'vue-router'
export default{
    components:{
        'loading': Loader,
    },
    setup(){
        return {
            letter:reactive({}),
            loaded:ref(false)
        }
    },
    beforeMount(){
        
        const route = useRoute();
        const hiddenRoutes = ['disputes-letter-edit'];
        if(hiddenRoutes.includes(route.name)){
            this.getCustomLetter();
        }else{
            this.letter = [];
            this.loaded = true
        }
    },
    methods:{
        getCustomLetter(){
            let $this = this;
            const route = this.$router.resolve(
                {
                    name: 'disputes-letter-edit',
                }
            );
            axios.get(
                route.href
            ).then(function(response) {
                if(response.data.error == true) {
                    $this.loaded = true;
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.loaded = true;
                Object.assign($this.letter, response.data.data);
                return;
            }).catch(function(error) {
                $this.loaded = true;
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        }
    }
}
</script>
